// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"728":"usuarios","913":"default"}[chunkId] || chunkId) + "-legacy." + {"386":"5410519e","728":"e21415fb","913":"8667afca"}[chunkId] + ".js";
};